import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = 0;
  private _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  show() {
    this.requestCount++;
    if (this.requestCount > 0) {
      this._isLoading.set(true);
    }
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0; // Prevenir números negativos
      this._isLoading.set(false);
    }
  }
}
